import { render, staticRenderFns } from "./price-update-box.vue?vue&type=template&id=59a3c959&scoped=true&lang=pug"
import script from "./price-update-box.vue?vue&type=script&lang=ts"
export * from "./price-update-box.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a3c959",
  null
  
)

export default component.exports